import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { compose } from 'recompose';
import { IRootState } from '../../../typings';
import { duplicateSurvey, getSurvey, translateSurvey, updateSurvey } from '../actions';
import { getAtInternetStat } from '../Stats/action';

type IOwnProps = RouteComponentProps<{ topicId: string }>;

const mapDispatchToProps = {
  fetchSurvey: getSurvey,
  fetchAnalyticStat: getAtInternetStat,
  updateSurvey,
  translateSurvey,
  duplicateSurvey,
};

const mapStateToProps = (state: IRootState, ownProps: IOwnProps) => {
  const id = ownProps.match.params.topicId;
  return {
    id,
    survey: state.survey.detail[id],
    fetching: state.survey.fetching,
    me: state.me,
  };
};

export type IComponentProps = typeof mapDispatchToProps &
  ReturnType<typeof mapStateToProps> &
  InjectedIntlProps &
  IOwnProps;

const reduxConnector = connect(
  mapStateToProps,
  mapDispatchToProps
);

export const connector = compose<IComponentProps, IOwnProps>(
  reduxConnector,
  injectIntl
);
